module.exports = __webpack_public_path__ + "img/dousha.79d3f535.jpg";